<div class="container padding-top-10 padding-bottom-10">
  <uib-alert ng-show="url" type="info">
    <a ng-href="{{url}}" target="_blank">
      Relatório gerado com sucesso! <strong>Clique aqui para baixar</strong>
    </a>
  </uib-alert>

  <div class="jumbotron">
    <h1>Relatório de Fechamento</h1>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <ui-select ng-model="filters.safra" theme="bootstrap" id="safra" name="safra" required>
            <ui-select-match allow-clear="true" placeholder="Selecione a safra...">{{$select.selected.descricao}}</ui-select-match>
            <ui-select-choices repeat="safra in safras | orderBy: '-descricao' | filter: $select.search">
              <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <ui-select ng-model="filters.atividade" theme="bootstrap" id="atividade" name="atividade" required>
            <ui-select-match allow-clear="true" placeholder="Selecione a atividade...">{{$select.selected.descricao}}</ui-select-match>
            <ui-select-choices repeat="atividade in atividades | orderBy: 'descricao' | filter: $select.search">
              <span class="form-group" ng-bind-html="atividade.descricao | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <ui-select multiple ng-model="filters.glebas" theme="bootstrap" id="glebas" name="glebas" required>
            <ui-select-match allow-clear="true" placeholder="Selecione os talhões...">{{$item.descricao | capitalize}}</ui-select-match>
            <ui-select-choices repeat="gleba in glebasPropriedade | orderBy: 'descricao' | filter: $select.search">
              <span ng-bind-html="gleba.descricao | capitalize | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
          <div class="text-right">
            Selecionar:&nbsp;
            <div class="btn-group">
              <button type="button" class="btn btn-white btn-xs" ng-click="allGlebas()">Todas</button>
              <button type="button" class="btn btn-white btn-xs" ng-click="clearGlebas()">Nenhuma</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="checkbox m-t-none m-b-md">
          <label>
            <input ng-model="filters.timeline" type="checkbox"> Incluir timeline ocorrências/pulverizações
          </label>
        </div>
      </div>
      <div class="col-md-6" ng-show="filters.timeline">
        <div class="checkbox m-t-none m-b-md">
          <label>
            <input ng-model="filters.exibir_fotos" type="checkbox"> Incluir fotos na timeline para ocorrências{{filters.exibir_anotacoes ? '/anotações' : ''}}
          </label>
        </div>
      </div>
      <div class="col-md-6" ng-show="filters.timeline">
        <div class="checkbox m-t-none m-b-md">
          <label>
            <input ng-model="filters.exibir_anotacoes" type="checkbox"> Incluir anotações na timeline
          </label>
        </div>
      </div>
    </div>
    <span>
      <span ng-if="loadingRelatorio">
        <i class="fa fa-spinner fa-spin"></i>
        <h4 class="text-cinza"> O seu relatório está sendo gerado, iremos avisar assim que o processo concluir. </h4>
      </span>
      <p><button ng-if="!loadingRelatorio" class="btn btn-primary btn-lg" type="button"
          ng-disabled="!filters.safra || !filters.atividade || !filters.glebas" ng-click="gerar()">Iniciar geração</button>
      </p>
    </span>
  </div>
</div>
